$(document).ready(function() {
  var swiperThumb = new Swiper("#product_thumbnails", {
      spaceBetween: 10,
      slidesPerView: 5,
      // simulateTouch: true,
    });
  
  var swiperFeatured = new Swiper("#product_media_mobile", {
      spaceBetween: 5,
      thumbs: {
        swiper: swiperThumb,
      },
      on: { 
        realIndexChange: (swiper) => {
          if(swiper.realIndex != 0) {
            $('#featured_stickers').hide();
          }else {
            $('#featured_stickers').show();
          }
        } 
      }, 
    });

  $('#slide3').click(swiperFeatured,function(){
      swiperFeatured.slideTo(swiperFeatured.slides.length -1);
  });
  
  // swiperFeatured.on('transitionEnd', function () {
  //   console.log('slide changed' + swiperThumb.realIndex);
  // });

  
  // var swiperFeatured = new Swiper("#product_media_mobile", {
  //     spaceBetween: 5,
  //     slidesPerView: 1,
  //   });
  
  $('#product_media_mobile .swiper-wrapper .swiper-slide').remove();
  function loadInitialImages() {
    swiperFeatured.updateSlides();
    swiperThumb.updateSlides();
    let initial_image = $(".swatch div.swatch-element input[name='option-1']:checked").val().toLowerCase().replace(/\s+/g, '-');
    let mediaJson = $('.media_slider').data('media-json');
    let mediaLength = $('.media_slider').data('media-length');
    const swiper_thumbnails = $('#product_thumbnails .swiper-wrapper');
    var checked_variant_size = false;
      if($('body').attr('id') === 'desk-mat' || $('body').attr('id').includes('orbitkey-desk-mat') || $('body').attr('id').includes('hybrid-laptop-sleeve') || $('body').attr('id').includes('compendium')  ) {
        var checked_variant_size = $("input[name='option-2']:checked").val().toLowerCase().replace(/\s+/g, '-');
      }
      
      if(checked_variant_size){ 
        initial_image = initial_image+'-'+checked_variant_size;
      }
    
    let z = 0;
    
    for(let i = 0; i < mediaLength; i++) {
        let currentMedia = mediaJson[i + 1];
        if(currentMedia.media_type === 'image') {
              // if(currentMedia.src.indexOf(initial_image) !== -1) {
              if(currentMedia.alt == initial_image) {
                swiperFeatured.appendSlide($(`<div class="swiper-slide"><div class="product-medias__media"><img src="${currentMedia.src.includes('.jpg') ? currentMedia.src.replace('.jpg', '_1000x1000.jpg') : currentMedia.src.replace('.png', '_1000x1000.png')}" loading=lazy></div></div>`));
                // $(`<div class="swiper-slide product-thumbs-slides"><div class="responsive-image-product-wrapper"><img src="${currentMedia.src.includes('.jpg') ? currentMedia.src.replace('.jpg', '_200x200.jpg') : currentMedia.src.replace('.png', '_200x200.png')}" data-thumbnail-id="${z}"></div></div>`).appendTo(swiper_thumbnails);
                swiperThumb.appendSlide($(`<div class="swiper-slide product-thumbs-slides"><div class="responsive-image-product-wrapper"><img src="${currentMedia.src.includes('.jpg') ? currentMedia.src.replace('.jpg', '_200x200.jpg') : currentMedia.src.replace('.png', '_200x200.png')}" data-thumbnail-id="${z}"></div></div>`));
                  z++;
              }
        }

        if(currentMedia.media_type === 'video') {
          swiperFeatured.appendSlide($(`<div class="swiper-slide"><div class=""><video width="100%" height="100%" playsinline controls autoplay muted loop><source src="${currentMedia.sources[0].url}" type="video/mp4"></video></div></div>`));
          swiperThumb.appendSlide($(`<div class="swiper-slide product-thumbs-slides"><div style="height:100%" class="responsive-image-product-wrapper"><img src="${currentMedia.preview_image.src.includes('.jpg') ? currentMedia.preview_image.src.replace('.jpg', '_200x200.jpg') : currentMedia.preview_image.src.replace('.png', '_200x200.png')}" data-thumbnail-id="${z}"></div></div>`));
          z++;
        }
      
    }
  }
  loadInitialImages();
  
  $(".swatch div.swatch-element").unbind('click');
  $(".swatch div.swatch-element").click(function() {
  const swiper_thumbnails = $('#product_thumbnails .swiper-wrapper');
 
  $('#product_thumbnails .swiper-wrapper .swiper-slide').remove();
  $('#product_media_mobile .swiper-wrapper .swiper-slide').remove();
  loadInitialImages();    
  $('.color-switch-header').html('Color: ' + $("input[name='option-1']:checked").val());
    
  });

  var _carousel_swiper = new Swiper(".owl-carousel-desk-mat-compare", {
      spaceBetween: 0,
      slidesPerView: 3,
      loop: false,
      dots: false,
      breakpoints: {
        0:{
            slidesPerView:1,
            spaceBetween:0,
        },
        600:{
            slidesPerView:1,
			spaceBetween:10,
        },
        769:{
            slidesPerView:1,
			spaceBetween:10,
        },
        1000:{
            slidesPerView:3,
			spaceBetween:0,
        }
      }
    
      // simulateTouch: true,
    });
  


  if($('.desk-mat-compare-buttons .swatch-element').length) {
    $('.desk-mat-compare-buttons .swatch-element').click(function() {
      const _this = $(this);
      let sizeSwatch = $('.desk-mat-compare-buttons input[type="radio"]:checked');
	  // If swatches are checked
      if(sizeSwatch.length) {        
        if(sizeSwatch.val() == 1) {
          $(".owl-carousel-desk-mat-compare[data-slider-id='0'").addClass('hide');
          $(".owl-carousel-desk-mat-compare[data-slider-id='1'").toggleClass('hide');
          $(".owl-carousel-desk-mat-compare[data-slider-id='2'").addClass('hide');           
        } else if(sizeSwatch.val() == 2) {
          $(".owl-carousel-desk-mat-compare[data-slider-id='0'").addClass('hide');
          $(".owl-carousel-desk-mat-compare[data-slider-id='1'").addClass('hide');
          $(".owl-carousel-desk-mat-compare[data-slider-id='2'").toggleClass('hide');          
        } else {
           $(".owl-carousel-desk-mat-compare[data-slider-id='0'").toggleClass('hide');
          $(".owl-carousel-desk-mat-compare[data-slider-id='1'").addClass('hide');
          $(".owl-carousel-desk-mat-compare[data-slider-id='2'").addClass('hide');
        }
      } else {
       $('.desk-mat-compare-buttons input[type="radio"]').first().prop("checked", true);
      }
    });
   }

});